export var SapScheduleStart;
(function (SapScheduleStart) {
    SapScheduleStart["SAP_SCHEDULE_START_NOW"] = "NOW";
    SapScheduleStart["SAP_SCHEDULE_START_SCHEDULED"] = "SCHEDULED";
})(SapScheduleStart || (SapScheduleStart = {}));
